import React from 'react';

export const Banner = ({ pillText, title, subtitle, reduced = false, titleClassName = '' }) => {
  // Exact spacing model from My Favorites:
  // - section provides pt-8
  // - image under banner
  // - pill: mt-4
  // - heading: mt-8
  const wrapperClasses = `w-full ${reduced ? 'mt-8' : 'mt-0'} mb-6`;
  const scaleStyle = reduced ? { transform: 'scale(0.85)', transformOrigin: 'top center' } : {};

  return (
    <div className={wrapperClasses}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center text-center">
          <img
            src="/api/uploads/grr-banner-2025-new.jpg"
            alt="Gym Rat Rehab LLC - Physical Therapy in Gilbert Arizona - Sports Injury and Orthopedic Rehabilitation"
            className={`w-full h-auto ${reduced ? 'max-h-80' : 'max-h-96'} object-contain mx-auto`}
            style={scaleStyle}
          />
          {pillText ? (
            <div className="mt-4">
              <span
                className="inline-block px-5 py-2 text-lg font-semibold uppercase tracking-wide rounded-full"
                style={{ backgroundColor: 'rgba(232, 184, 109, 0.2)', color: 'var(--brand-primary)' }}
              >
                {pillText}
              </span>
            </div>
          ) : null}

          {title ? (
            <div className="text-center mt-8">
              <h1 className={`heading-1 mb-6 ${titleClassName}`}>{title}</h1>
              {subtitle ? (
                <p className="body-large max-w-3xl mx-auto">{subtitle}</p>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Banner;